import { ChangeDetectorRef, Component, OnDestroy, OnInit, signal, TemplateRef, ViewChild } from '@angular/core';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getCode } from 'app/utils/method';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CompanyAttributes, NotificationTemplateAttributes } from '@albatrosdeveloper/ave-models-package';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import DistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity';
import { DistributionChainService } from '../../configuration/distribution-chain/distribution-chain.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ICreateNotification, IUpdateNotification } from './interfaces/notification.service';
import { NotificationService } from './n-notification.service';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import NotificationAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification/notification.entity';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { NotificationsFiltersComponent } from '../../filters/notifications-filters/notifications-filters.component';
import NotificationGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-group/notification-group.entity';
import { GroupNotificationService } from '../n-group/n-group.service';
import { MemberNotificationService } from '../n-member/n-member.service';
import NotificationMemberAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/notification-member.entity';
import { NotificationFrequencyEnum, NotificationPriorityEnum, NotificationSourceEnum, NotificationTemplateStatusEnum, NotificationTypesEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { TableMembersComponent } from "./table-members/table-members.component";
import { TemplateService } from '../n-template/n-template.service';
import { MatCardModule } from '@angular/material/card';
import { SharedStateService } from '../shared/shared-state.service';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
interface TemplateFilters {
  status: number[];
  companyIds?: string[];
}
interface PriorityObject {
  code: NotificationPriorityEnum;
  name: string;
}
@Component({
  selector: 'app-n-notification',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    FilterComponent,
    NotificationsFiltersComponent,
    TableMembersComponent,
    HoverMenuDirective
  ],
  templateUrl: './n-notification.component.html',
  styleUrl: './n-notification.component.scss',
})
export class NNotificationComponent implements OnDestroy, OnInit {
  getCode = getCode
  notificationTypesEnum = NotificationTypesEnum
  displayedColumns: string[] = [
    "typeId",
    "priority",
    "name",
    "company",
    "salesOffice",
    "statusId",
    "action"
  ];

  dataSource = new MatTableDataSource<any>([]);
  name = signal('');
  showValidation = false;
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof any = "company";
  sortDirection: "ASC" | "DESC" = "ASC";
  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []
  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList = signal<SalesOfficeAttributes[]>([]);
  searchOffice = ''
  notificationGroupList: NotificationGroupAttributes[] = [];
  notificationMemberList: NotificationMemberAttributes[] = [];
  listChannel: number[] = Object.values(NotificationTypesEnum).filter((value): value is number => typeof value === 'number');
  listSource: number[] = Object.values(NotificationSourceEnum).filter((value): value is number => typeof value === 'number');
  listFrequency: number[] = Object.values(NotificationFrequencyEnum).filter((value): value is number => typeof value === 'number');
  interestedUsersList: boolean = false;
  isLoadingSalesOffices: boolean = false;
  listPriority = [
    { code: 0, name: 'Ahora' },
    { code: 1, name: 'Programado' }
  ]
  listPriorityOptions = [
    { code: NotificationPriorityEnum.LOW, name: 'Baja' },
    { code: NotificationPriorityEnum.MEDIUM, name: 'Media' },
    { code: NotificationPriorityEnum.HIGH, name: 'Alta' }
  ];

  listTemplate: NotificationTemplateAttributes[] = [];
  currentNotification: ICreateNotification = this.initializeCreateGroup();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;
  selectedStatuses: number[] = [0, 1];

  companyEntitiesFormGroup = new FormGroup({
    companyId: new FormControl(null),
    //distributionChainId: new FormControl(null),
    salesOfficeId: new FormControl(null),
    notificationGroupId: new FormControl(null),
    notificationMemberId: new FormControl(null),
  });
  private templatesSubscription?: Subscription

  constructor(
    private notificationService: NotificationService,
    private readonly companyService: CompanyService,
    //private readonly distributionChainService: DistributionChainService,  
    private readonly salesOfficeService: SalesOfficeService,
    private readonly templateService: TemplateService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private sharedStateService: SharedStateService,
    private snackBar: MatSnackBar,
    private groupNotificationService: GroupNotificationService,
    private memberNotificationService: MemberNotificationService
  ) { }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
    this.fetchNotificationMembers();
    this.companyEntitiesFormGroup.get("companyId")?.valueChanges.subscribe(companyId => {
      if (companyId) {
        this.fetchNotificationGroups(companyId);
      } else {
        this.notificationGroupList = [];
      }
    });
  }

  getPriorityLabel(priorityObj: NotificationPriorityEnum | PriorityObject | null | undefined): string {
  if (typeof priorityObj === 'object' && priorityObj !== null && 'name' in priorityObj) {
    return priorityObj.name;
  }
  
  if (typeof priorityObj === 'number') {
    const priorityItem = this.listPriorityOptions.find(p => p.code === priorityObj);
    return priorityItem ? priorityItem.name : String(priorityObj);
  }
  
  return '';
}

  get hasMembers(): boolean {
    return (this.currentNotification.members?.length || 0) > 0;
  }


  ngOnInit(): void {
    this.sharedStateService.templatesUpdated$.subscribe((updated) => {
      if (updated) {
        this.getList();
        this.sharedStateService.resetTemplatesState();
      }
    });
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  getList(): void {

    //const distributionChainValue = this.companyEntitiesFormGroup.getRawValue().distributionChainId
    //const distributionChainIds = Array.isArray(distributionChainValue) ? distributionChainValue : distributionChainValue ? [distributionChainValue] : [];

    const salesOfficeValue = this.companyEntitiesFormGroup.getRawValue().salesOfficeId
    const salesOfficeIds = Array.isArray(salesOfficeValue) ? salesOfficeValue : salesOfficeValue ? [salesOfficeValue] : [];

    const notificationGroupValue = this.companyEntitiesFormGroup.getRawValue().notificationGroupId
    const notificationGroupIds = Array.isArray(notificationGroupValue) ? notificationGroupValue : notificationGroupValue ? [notificationGroupValue] : [];

    const notificationMemberValue = this.companyEntitiesFormGroup.getRawValue().notificationMemberId
    const notificationMemberIds = Array.isArray(notificationMemberValue) ? notificationMemberValue : notificationMemberValue ? [notificationMemberValue] : [];

    this.notificationService.getAllPaginate({
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.sortActive as keyof NotificationAttributes,
      sortDirection: this.sortDirection
    }, {
      statusIds: this.selectedStatuses,
      companyIds: this.companyEntitiesFormGroup.getRawValue().companyId ? [this.companyEntitiesFormGroup.getRawValue().companyId] : [],
      //distributionChainIds: distributionChainIds,
      salesOfficeIds: salesOfficeIds,
      notificationGroupIds: notificationGroupIds,
      notificationMemberIds: notificationMemberIds
    }).subscribe({
      next: (res: IPaginationResult<any>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener notificaciones", "Cerrar", { duration: 5000 });
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateGroup(): ICreateNotification {
    const now = new Date();

    const pad = (n: number): string => n < 10 ? `0${n}` : `${n}`;
    const formattedDate = `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`;
    const formattedHour = `${pad(now.getHours())}:${pad(now.getMinutes())}`;

    return {
      code: "",
      externalKey: null,
      name: null,
      companyId: null,
      salesOfficeId: null,
      typeId: NotificationTypesEnum.EMAIL,
      sourceId: NotificationSourceEnum.USER,
      frequency: NotificationFrequencyEnum.ONE_TIME,
      scheduled: 0,
      template: null,
      date: formattedDate,
      hour: formattedHour,
      initDate: null,
      initTime: null,
      endDate: null,
      frequencyInterval: null,
      scheduledDate: null,
      scheduledTime: null,
      members: [],
      copyMembers: [],
      priorityId: NotificationPriorityEnum.MEDIUM,
      isForInterestedUser: false

    };
  }

  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open('Error al obtener las compañias', 'Cerrar', { duration: 3000 });
      }
    });
  }
  onCompanySelectionChange(companyId: string): void {
    // Limpiar la oficina seleccionada cuando cambia la compañía
    this.currentNotification.salesOfficeId = '';
    this.currentNotification.template = null;
    this.searchOffice = '';

    if (companyId) {
      this.getAllSalesOfficeList(companyId);
      this.getAllTemplates(companyId); // Cargar plantillas filtradas

    } else {
      this.salesOfficeList = [];
      this.listFilterSalesOfficeList.update(() => []);
      this.listTemplate = []; // Limpiar plantillas
    }
  }


  getAllSalesOfficeList(companyId: string): void {
    this.isLoadingSalesOffices = true;
    this.salesOfficeService.findToComboBox(companyId).subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
        this.isLoadingSalesOffices = false; // Agregar esta línea

      },
      error: (err) => {
        this.snackBar.open('Error al obtener las oficinas de venta.', 'Cerrar', { duration: 3000 });
        this.isLoadingSalesOffices = false; // Agregar esta línea
      },
    });
  }

  changueOptionsSalesOffice(event) {
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList.update(() => this.salesOfficeList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }

  getAllTemplates(companyId?: string) {
    const filters: TemplateFilters  = { status: [1] };
    // Agregar filtro por compañía si está disponible
    if (companyId) {
      filters.companyIds = [companyId];
    }

    this.templateService.getAllPaginate(
      {
        currentPage: 1,
        limitPerPage: Number.MAX_SAFE_INTEGER,
        sort: "name",
        sortDirection: "ASC"
      },
      filters
    ).subscribe({
      next: (res) => {
        this.listTemplate = res.data[0].data;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open('Error no se encontraron plantillas.', 'Cerrar', { duration: 3000 });
      },
    });
  }

  onFrequencyChange(): void {
    this.currentNotification.initDate = null;
    this.currentNotification.initTime = null;
    this.currentNotification.endDate = null;
    this.currentNotification.frequencyInterval = null;
    this.currentNotification.scheduledDate = null;
    this.currentNotification.scheduledTime = null;
  }


  shouldShowFrequencyFields(): boolean {
    const frequency = this.currentNotification.frequency;
    return frequency !== null && frequency !== undefined && frequency !== 7;
  }


  requiresInitDate(): boolean {
    const frequency = this.currentNotification.frequency;
    return [0, 1, 3, 4, 5, 6, 8].includes(frequency);
  }

  requiresEndDate(): boolean {
    const frequency = this.currentNotification.frequency;
    return [0, 1, 3, 4].includes(frequency);
  }

  requiresTime(): boolean {
    const frequency = this.currentNotification.frequency;
    return [0, 1, 3, 4, 5, 6, 8].includes(frequency);
  }


  requiresFrequencyInterval(): boolean {
    const frequency = this.currentNotification.frequency;
    return [5, 6].includes(frequency);
  }
  requiresLastNotificationDate(): boolean {
    const frequency = this.currentNotification.frequency;
    return [5, 6].includes(frequency);
  }


  requiresScheduledDate(): boolean {
    const frequency = this.currentNotification.frequency;
    return frequency === 8;
  }

  getIntervalLabel(): string {
    const frequency = this.currentNotification.frequency;
    switch (frequency) {
      case 5: return 'Intervalo en Horas';
      case 6: return 'Intervalo en  Minutos';
      default: return 'Intervalo';
    }
  }

  getIntervalHint(): string {
    const frequency = this.currentNotification.frequency;
    switch (frequency) {
      case 5: return 'Ejemplo: cada 4 horas, cada 5 horas';
      case 6: return 'Ejemplo: cada 20 minutos, cada 50 minutos';
      default: return '';
    }
  }

  onMembersChange(members: NotificationMemberAttributes[]): void {
    this.currentNotification.members = members;
  }


  onCopyMembersChange(copyMembers: NotificationMemberAttributes[]): void {
    this.currentNotification.copyMembers = copyMembers;
  }

  validateFrequencyFields(): boolean {
    const frequency = this.currentNotification.frequency;

    switch (frequency) {
      case 0:
      case 1:
      case 3:
      case 4:
        return !!(this.currentNotification.initDate &&
          this.currentNotification.initTime);

      case 5:
        return !!(this.currentNotification.initDate &&
          this.currentNotification.initTime &&
          this.currentNotification.frequencyInterval &&
          this.currentNotification.frequencyInterval > 0);

      case 6:
        return !!(this.currentNotification.initDate &&
          this.currentNotification.initTime &&
          this.currentNotification.frequencyInterval &&
          this.currentNotification.frequencyInterval > 0);

      case 7:
        return true;

      case 8:
        return !!(this.currentNotification.scheduledDate &&
          this.currentNotification.scheduledTime);
      
      case 9:
        return true;

      default:
        return false;
    }
  }

  private prepareDataForSubmission(): any {
    const dataToSend: any = Object.entries(this.currentNotification)
      .reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && !(Array.isArray(value) && value.length === 0)) {
          acc[key] = value;
        }
        return acc;
      }, {});

    const apiPayload: any = {
      name: dataToSend.name,
      typeId: dataToSend.typeId,
      sourceId: dataToSend.sourceId,
      frequency: dataToSend.frequency,
      statusId: 1,
      companyId: dataToSend.companyId,
      salesOfficeId: dataToSend.salesOfficeId,
      templateId: dataToSend.template,
      members: dataToSend.members && Array.isArray(dataToSend.members)
        ? dataToSend.members.map(member => member._id ? member._id.toString() : member.toString())
        : [],
      copyMembers: dataToSend.copyMembers && Array.isArray(dataToSend.copyMembers)
        ? dataToSend.copyMembers.map(member => member._id ? member._id.toString() : member.toString())
        : []
    };

    if (dataToSend.priorityId !== undefined) {
      apiPayload.priorityId = dataToSend.priorityId;
    }

    const frequency = dataToSend.frequency;
    if (dataToSend.priorityId !== undefined) {
      apiPayload.priorityId = dataToSend.priorityId;
    }

    // AGREGAR ESTA SECCIÓN:
    if (dataToSend.isForInterestedUser !== undefined) {
      apiPayload.isForInterestedUser = Boolean(dataToSend.isForInterestedUser);
    }

    if ([0, 1, 3, 4].includes(frequency)) {
      if (dataToSend.initDate) {
        const initDateTime = new Date(dataToSend.initDate);
        if (dataToSend.initTime) {
          const [hours, minutes] = dataToSend.initTime.split(':');
          initDateTime.setHours(parseInt(hours), parseInt(minutes));
        } else {
          initDateTime.setHours(0, 0, 0, 0);
        }
        apiPayload.initDate = initDateTime.toISOString();
      }

      if (dataToSend.endDate) {
        const endDateTime = new Date(dataToSend.endDate);
        if (dataToSend.initTime) {
          const [hours, minutes] = dataToSend.initTime.split(':');
          endDateTime.setHours(parseInt(hours), parseInt(minutes));
        } else {
          endDateTime.setHours(23, 59, 59, 999);
        }
        apiPayload.endDate = endDateTime.toISOString();
      }
    }

    if (frequency === 5) {
      if (dataToSend.initDate) {
        const initDateTime = new Date(dataToSend.initDate);
        if (dataToSend.initTime) {
          const [hours, minutes] = dataToSend.initTime.split(':');
          initDateTime.setHours(parseInt(hours), parseInt(minutes));
        } else {
          initDateTime.setHours(0, 0, 0, 0);
        }
        apiPayload.initDate = initDateTime.toISOString();
      }

      if (dataToSend.frequencyInterval) {
        apiPayload.frequencyInterval = dataToSend.frequencyInterval;
      }

      if (dataToSend.endDate) {
        const lastNotificationDateTime = new Date(dataToSend.endDate);
        if (dataToSend.scheduledTime) {
          const [hours, minutes] = dataToSend.scheduledTime.split(':');
          lastNotificationDateTime.setHours(parseInt(hours), parseInt(minutes));
        } else {
          lastNotificationDateTime.setHours(0, 0, 0, 0);
        }
        apiPayload.endDate = lastNotificationDateTime.toISOString();
      }
    }

    if (frequency === 6) {
      if (dataToSend.frequencyInterval) {
        apiPayload.frequencyInterval = dataToSend.frequencyInterval;
      }

      if (dataToSend.endDate) {
        const lastNotificationDateTime = new Date(dataToSend.endDate);
        if (dataToSend.scheduledTime) {
          const [hours, minutes] = dataToSend.scheduledTime.split(':');
          lastNotificationDateTime.setHours(parseInt(hours), parseInt(minutes));
        } else {
          lastNotificationDateTime.setHours(0, 0, 0, 0);
        }
        apiPayload.endDate = lastNotificationDateTime.toISOString();
      }
    }

    if (frequency === 7) {
      const now = new Date();
      apiPayload.initDate = now.toISOString();
      apiPayload.scheduledDate = now.toISOString();
      apiPayload.executionDate = now.toISOString(); // Si existe este campo
      apiPayload.isAutomatic = true;
    }

    if (frequency === 8) {
      if (dataToSend.scheduledDate) {
        const scheduledDateTime = new Date(dataToSend.scheduledDate);
        if (dataToSend.scheduledTime) {
          // Parsear correctamente el formato de 12 horas
          const timeStr = dataToSend.scheduledTime.trim();
          // Extraer AM/PM
          const isPM = timeStr.includes('PM');
          const isAM = timeStr.includes('AM');
          // Remover AM/PM y parsear
          const timeOnly = timeStr.replace(/\s*(AM|PM)\s*/i, '');
          const [hours, minutes] = timeOnly.split(':');
          let hour24 = parseInt(hours);
          // Convertir a formato 24 horas
          if (isPM && hour24 !== 12) {
            hour24 += 12;
          } else if (isAM && hour24 === 12) {
            hour24 = 0;
          }
          scheduledDateTime.setHours(hour24, parseInt(minutes), 0, 0);
        } else {
          scheduledDateTime.setHours(0, 0, 0, 0);
        }
        apiPayload.scheduledDate = scheduledDateTime.toISOString();
      }
    }

    const finalPayload = Object.entries(apiPayload)
      .reduce((acc, [key, value]) => {
        if (key === "copyMembers" || key === "members") {
          acc[key] = value ?? [];
        } else if (value !== '' && value !== null && !(Array.isArray(value) && value.length === 0)) {
          acc[key] = value;
        }
        return acc;
      }, {});
    return finalPayload;
  }

  private extractTimeFromDate(dateString: string): string {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 debería ser 12
    const hoursStr = hours.toString();
    const minutesStr = minutes.toString().padStart(2, '0');
    return `${hoursStr}:${minutesStr} ${ampm}`;
  }

  openModal(notification?: any): void {
    this.getAllCompanies()
    //this.fetchAllDistributionChain()

    if (notification) {
      if (notification.company) {
        this.getAllSalesOfficeList(notification.company._id)
        this.getAllTemplates(notification.company._id.toString()); // Filtrar por compañía
      }

      this.currentNotification = {
        ...notification,
        code: notification.code, //no debo mandar
        externalKey: this.getCode(notification) ? this.getCode(notification) : null,
        companyId: notification.company ? notification.company._id.toString() : "",
        salesOfficeId: notification.salesOffice ? notification.salesOffice._id.toString() : null,
        scheduled: notification.date && notification.hour ? 1 : 0,
        template: notification.template ? notification.template._id.toString() : null,
        frequency: Number(notification.frequency ?? NotificationFrequencyEnum.ONE_TIME),
        initDate: notification.initDate ? new Date(notification.initDate) : null,
        initTime: notification.initDate ? this.extractTimeFromDate(notification.initDate) : null,
        endDate: notification.endDate ? new Date(notification.endDate) : null,
        frequencyInterval: notification.frequencyInterval || null,
        scheduledDate: notification.scheduledDate ? new Date(notification.scheduledDate) : null,
        scheduledTime: notification.scheduledDate ? this.extractTimeFromDate(notification.scheduledDate) : null,
        members: JSON.parse(JSON.stringify(notification.members || [])),
        copyMembers: JSON.parse(JSON.stringify(notification.copyMembers || [])),
        priorityId: notification.priorityId !== undefined ? notification.priorityId : NotificationPriorityEnum.MEDIUM,
        isForInterestedUser: notification.isForInterestedUser !== undefined ? notification.isForInterestedUser : false
      };

      if (notification.date && typeof notification.date === 'string') {
        const [day, month, year] = notification.date.split('-').map(Number);
        const dateObj = new Date(year, month - 1, day);
        this.currentNotification.date = dateObj;
      }

      this.id = notification._id;
      this.getAllSalesOfficeList(notification.company._id.toString());

    } else {
      this.getAllTemplates();
      this.currentNotification = this.initializeCreateGroup();
      this.id = null
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '65%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }



  onSubmit() {
    this.showValidation = true;
    if (!this.hasMembers) {
      this.snackBar.open('Debe agregar al menos un destinatario principal', 'Cerrar', { duration: 5000 });
      return;
    }
    if (this.id == null) {
      this.createNotification()
    } else {
      this.updateNotification(this.id)
    }
  }

  createNotification(): void {
    if (!this.validateFrequencyFields()) {
      this.snackBar.open('Faltan campos requeridos para la frecuencia seleccionada', 'Cerrar', { duration: 5000 });
      return;
    }

    const dataToSend: any = this.prepareDataForSubmission();
    this.notificationService.create(dataToSend).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if (this.dialogRef) {
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateNotification(id: string): void {
    if (!this.validateFrequencyFields()) {
      this.snackBar.open('Faltan campos requeridos para la frecuencia seleccionada', 'Cerrar', { duration: 5000 });
      return;
    }
    const dataToSend: any = this.prepareDataForSubmission();


    this.notificationService.update(id, dataToSend).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        if (this.dialogRef) {
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  onStatusChange(event: boolean, notification: any): void {
  const originalStatusId = notification.statusId;
  const updatedStatusId = event ? 1 : 0;

  const updatedData: IUpdateNotification = {
    name: notification.name,
    companyId: notification.company ? notification.company._id.toString() : notification.companyId,
    salesOfficeId: notification.salesOffice ? notification.salesOffice._id.toString() : notification.salesOfficeId,
    type: notification.typeId,
    sourceId: notification.sourceId,
    template: notification.template ? notification.template._id.toString() : (notification.templateId || ''),
    statusId: updatedStatusId,
    frequency: notification.frequency,
    priorityId: notification.priorityId,
    isForInterestedUser: notification.isForInterestedUser,
    members: notification.members && Array.isArray(notification.members)
      ? notification.members.map((member: NotificationMemberAttributes) => 
          member._id ? member._id.toString() : member.toString())
      : [],
    copyMembers: notification.copyMembers && Array.isArray(notification.copyMembers)
      ? notification.copyMembers.map((member: NotificationMemberAttributes) => 
          member._id ? member._id.toString() : member.toString())
      : []
  };

  const filteredData = Object.entries(updatedData)
    .reduce((acc, [key, value]) => {
      if (key === "copyMembers" || key === "members") {
        (acc as any)[key] = value ?? [];
      } else if (value !== '' && value !== null && !(Array.isArray(value) && value.length === 0)) {
        (acc as any)[key] = value;
      }
      return acc;
    }, {} as Partial<IUpdateNotification>);

  this.notificationService.update(notification._id.toString(), filteredData).subscribe({
    next: () => {
      this.getList();
      this.snackBar.open('Estado actualizado correctamente', 'Cerrar', { duration: 2000 });
    },
    error: (err) => {
      notification.statusId = originalStatusId;
      this.snackBar.open(err.error?.message || 'Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
      this.getList();
    }
  });
}

  openDeleteDialog(notification: any): void {
    this.dialog
      .open(this.deleteDialog, { data: notification, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(notification._id.toString()));
  }

  delete(id: string): void {
    this.notificationService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }
  toUppercase(event: Event) {
    const input = event.target as HTMLInputElement;
    this.name.set(input.value.toUpperCase());
  }

  convertTo24HourFormat(time12h?: string): string {

    if (!time12h) {
      const date = new Date();
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12;

      const pad = (n: number) => (n < 10 ? '0' + n : n);
      time12h = `${pad(hours)}:${pad(minutes)} ${ampm}`;
    }

    const [time, modifier] = time12h.trim().split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) {
      hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    const pad = (n: number) => n < 10 ? '0' + n : n;
    return `${pad(hours)}:${pad(minutes)}`;
  }

  convertToDateFormat(dateA?: any): string {
    const date = dateA ? new Date(dateA) : new Date();

    const pad = (n: number): string => n < 10 ? `0${n}` : `${n}`;
    const formattedDate = `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;

    return formattedDate;
  }

  onTimeSet(event: string): void {
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.templatesSubscription) {
      this.templatesSubscription.unsubscribe();
    }
  }

  applyStatusFilter() {
    this.pageIndex = 1
    this.getList()
  }

  onFilterEvent() {
    this.pageIndex = 1
    this.getList()
  }

  onClearEvent() {
    this.companyEntitiesFormGroup.reset()
    this.pageIndex = 1
    this.getList()
  }

  fetchNotificationGroups(companyId: string): void {
    this.groupNotificationService.getAllPaginate(
      {
        currentPage: 1,
        limitPerPage: Number.MAX_SAFE_INTEGER,
        sort: "name",
        sortDirection: "ASC"
      },
      {
        companyId: Number(companyId),
        status: [1]
      }
    ).subscribe({
      next: (res: IPaginationResult<NotificationGroupAttributes>) => {
        const groups = res?.data?.[0]?.data ?? [];
        this.notificationGroupList = groups.map(group => ({
          ...group,
          members: (group.members || []).filter(m => m.statusId === 1)
        }));
      },
      error: (err) => {
        this.snackBar.open('Error al obtener los grupos de notificacion.', 'Cerrar', { duration: 3000 });
      }
    });
  }

  fetchNotificationMembers(): void {
    this.memberNotificationService.getAllPaginate({
      currentPage: 1,
      limitPerPage: Number.MAX_SAFE_INTEGER,
      sort: "name",
      sortDirection: "ASC"
    }).subscribe((res: IPaginationResult<NotificationMemberAttributes>) => {
      this.notificationMemberList = res?.data?.[0]?.data ?? [];
    });
  }

  getListTypeLabel(type: number): string {
    const labels = {
      [NotificationTypesEnum.EMAIL]: 'Email',
      [NotificationTypesEnum.WHATSAPP]: 'Whatsapp',
      [NotificationTypesEnum.NOTIFICATIONS]: 'Notificaciones',
    };
    return labels[type] || type;
  }


  getListSourceLabel(type: number): string {
    const labels = {
      [NotificationSourceEnum.USER]: 'Usuario',
      [NotificationSourceEnum.SYSTEM]: 'Sistema',
    };
    return labels[type] || type;
  }

  getListStatusLabel(status: number): string {
    const labels = {
      [NotificationTemplateStatusEnum.ACTIVE]: 'Activo',
      [NotificationTemplateStatusEnum.DRAFT]: 'Borrador',
      [NotificationTemplateStatusEnum.ARCHIVED]: 'Archivado',
    };
    return labels[status] || status;
  }

  getFrequencyLabel(frequency: number): string {
    const labels = {
      [NotificationFrequencyEnum.D]: 'Diaria',
      [NotificationFrequencyEnum.W]: 'Semanal',
      [NotificationFrequencyEnum.M]: 'Mensual',
      [NotificationFrequencyEnum.Y]: 'Anual',
      [NotificationFrequencyEnum.NHOURS]: 'Cada ciertas horas',
      [NotificationFrequencyEnum.NMINUTES]: 'Cada ciertos minutos',
      [NotificationFrequencyEnum.AUTO_ON_CREATE]: 'Automática al crear',
      [NotificationFrequencyEnum.ONE_TIME]: 'Una sola vez programada',
      [NotificationFrequencyEnum.ON_EVENT]: 'En evento'
    };
    return labels[frequency] || String(frequency);
  }

  updateFormMembers(type: 'members' | 'copyMembers', members: any[]): void {

    if (Array.isArray(members)) {
      const membersCopy = JSON.parse(JSON.stringify(members));

      if (type === 'members') {
        this.currentNotification.members = membersCopy;
        if (members.length > 0) {
          this.showValidation = false;
        }
      } else if (type === 'copyMembers') {
        this.currentNotification.copyMembers = membersCopy;
      }

    } else {
      this.snackBar.open('Los dato recibidos no son validos.', 'Cerrar', { duration: 3000 });
    }
  }

}